import script from "./UserAuKycForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAuKycForm.vue?vue&type=script&setup=true&lang=ts"

import "./UserAuKycForm.vue?vue&type=style&index=0&id=3adc3982&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3adc3982"]])

export default __exports__